const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWM2LjA3NSAwIDExIDQuOTI1IDExIDExcy00LjkyNSAxMS0xMSAxMVMxIDE4LjA3NSAxIDEyIDUuOTI1IDEgMTIgMXptMCAyYTkgOSAwIDEgMCAwIDE4IDkgOSAwIDAgMCAwLTE4em0tMSA0djEwSDlWN2gyem00IDB2MTBoLTJWN2gyeiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=paused-e96ac89d.mjs.map
